import ManualBill from '../../../../bills/components/create/ManualBill';

export default function ManualBillScreen() {
    return <ManualBill />;
}
